import { makeStyles } from '@material-ui/core/styles';

export const useAuthorizeCheckboxStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '40px',
    margin: '40px auto',
  },
  text: {
    fontSize: 14,
    color: '#666666',
    '& a': {
      textDecoration: 'underline',
      fontWeight: 600,
      color: '#464646',
    },
  },
  checkbox: {
    color: `${theme.palette.primary.main}`,
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: `${theme.palette.primary.main}`,
    },
    '&.MuiCheckbox-colorSecondary.Mui-checked.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
}));
